import { render, staticRenderFns } from "./BldSearch.vue?vue&type=template&id=2fb24904&scoped=true&"
import script from "./BldSearch.vue?vue&type=script&lang=js&"
export * from "./BldSearch.vue?vue&type=script&lang=js&"
import style0 from "./BldSearch.vue?vue&type=style&index=0&id=2fb24904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb24904",
  null
  
)

export default component.exports